import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SURVEYS } from '../../../../../routes/paths';
import { asyncGetSurveyById } from '../../../../../services/survey.service';
import { Survey } from '../form/props';

export const useSurveyDetail = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [survey, setSurvey] = useState<Survey>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (Boolean(id)) {
            setLoading(true);
            asyncGetSurveyById(id!)
                .then((surveyData: any) => {
                    if (!surveyData) navigate(SURVEYS);
                    setSurvey(surveyData);
                })
                .finally(() => setLoading(false));
        }
    }, [id]);

    return {
        survey,
        loading,
    };
};
